import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { Link } from 'react-router';

import {
  FlexColCenter,
  FlexRowCenterVertical,
  FlexBetween,
} from '../../Defaults/Flexbox/Flexbox';
import { IconImg } from '../../Defaults/Icon/IconImg';

import { SanitasFooterRowWrapper as FooterRowWrapper } from './FooterRowWrapper';

export interface Props {
  links: any;
  images: any;
}

function FooterFirstRow({ links, images }: Props) {
  const imagesComponent =
    images &&
    images.map((i: any) => (
      <IconWrapper key={i.title}>
        <IconImg key={i.source} src={i.source} alt={i.title} />
      </IconWrapper>
    ));

  const linksComponent =
    links &&
    links.map((l: any, index: number) => (
      <>
        <SmallLink key={l.id} to={`/${l.url}`}>
          {l.name}
        </SmallLink>
        {links[index + 1] ? <DotDelimeter /> : null}
      </>
    ));
  return (
    <FooterRowWrapper>
      <LinkWrapper>
        {linksComponent && linksComponent.length > 0 ? linksComponent : null}
      </LinkWrapper>
      <MobileLinkWrapper>
        {linksComponent && linksComponent.length > 0 ? linksComponent : null}
      </MobileLinkWrapper>
      <a
        href="http://www.sukl.sk/buxus/generate_page.php?page_id=4380"
        target="blank"
      >
        <SuklLogo src="/images/sukl.png" />
      </a>

      <HeurekaBadgeWrapper>
        <div id="showHeurekaBadgeHere-1" />
      </HeurekaBadgeWrapper>

      <ImagesWrapper>
        {imagesComponent && imagesComponent.length > 0 ? imagesComponent : null}
      </ImagesWrapper>
    </FooterRowWrapper>
  );
}

const ImagesWrapper = styled(FlexRowCenterVertical)`
  ${({ theme }) => theme.mediab.l1050`
      margin-bottom: ${rem(16)};
    `};

  ${({ theme }) => theme.mediab.s450`
      margin-bottom: 0;
    `};
`;

const IconWrapper = styled(FlexBetween)`
  border: ${rem(1)} solid #ccc;
  border-radius: ${rem(4)};
  margin-right: ${rem(8)};
  height: ${rem(40)};
  width: ${rem(57)};
  padding: ${rem(6)};

  img {
    width: 100%;
    height: 100%;
  }

  :last-of-type {
    margin-right: 0;
  }

  ${({ theme }) => theme.mediab.m580`
      height: ${rem(32)};
      margin-right: ${rem(8)};
      width: ${rem(46)};
      padding: ${rem(5)};
    `}
`;

const LinkWrapper = styled(FlexRowCenterVertical)`
  justify-content: flex-start;
  margin-right: ${rem(16)};
  flex-wrap: wrap;
  align-content: center;
  width: 50%;

  ${({ theme }) => theme.mediab.l1050`
      margin-bottom: ${rem(16)};
      margin-right: 0;
    `};

  ${({ theme }) => theme.mediab.m580`
    display: none;
    `}
`;

const MobileLinkWrapper = styled(FlexColCenter)`
  display: none;
  justify-content: flex-start;
  flex-wrap: wrap;

  ${({ theme }) => theme.mediab.m580`
        display: flex;
    `}
`;

const SmallLink = styled(Link)`
  text-decoration: none;
  font-size: ${rem(14)};
  font-weight: 500;
  font-family: ${({ theme }) => theme.font.primary};
  color: ${({ theme }) => theme.colors.black};
  line-height: ${rem(18)};
  margin: ${rem(8)} 0;

  &:hover {
    text-decoration: underline;
  }

  ${({ theme }) => theme.mediab.m580`
    margin-bottom: ${rem(8)}
  `}
`;

const DotDelimeter = styled.span`
  margin: 0 ${rem(12)};
  height: ${rem(2)};
  width: ${rem(2)};
  background-color: ${({ theme }) => theme.colors.black};
  border-radius: 50%;
  display: inline-block;

  ${({ theme }) => theme.mediab.m580`
    display: none;
  `}
`;

const SuklLogo = styled.img`
  width: ${rem(165)};
  height: auto;
  margin: ${rem(16)} ${rem(16)} ${rem(16)} 0;
`;

const HeurekaBadgeWrapper = styled.div`
  width: ${rem(96)};
  max-width: ${rem(96)};
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ theme }) => theme.mediab.m580`
    margin-bottom: ${rem(16)};
  `}
`;
export { FooterFirstRow as SanitasFooterFirstRow };
